var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"align":"center"}},[_c('v-overlay',{staticStyle:{"height":"100vh"},attrs:{"value":_vm.overlay}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('iframe',{style:(_vm.size < 960
        ? 'width: 100%; height: calc(100vh - 16px)'
        : 'width: 100%; height: calc(100vh - 95px)'),attrs:{"src":_vm.gameUrl,"frameborder":"0"}}),_c('MisCuentas')],1)}
var staticRenderFns = []

export { render, staticRenderFns }